import { Injectable } from '@angular/core';

//Service file
import { ConfigurationQueryService } from '../queryFiles/index';
import { apiCalls, site } from '../utils';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';



@Injectable()
export class ConfigurationService {
  configurationQueryService: any;

  marketList: BehaviorSubject<any> = new BehaviorSubject({
    marketList: [],
  });

  constructor(
    private http: HttpClient,
    public configurationService: ConfigurationQueryService
  ) {
  }

  // to get product list
  getProductsList(limit: number, offset: number) {
    let queryParam = {};
    if (limit) {
      queryParam = {
        "limit": limit,
        "offset": offset
      }
    }

    return new Promise((resolve, reject) => {
      this.configurationService
        .GET_PRODUCTS(queryParam)
        .valueChanges
        .subscribe((response: any) => {
          if (response && response.data && response.data.allProducts) {
            resolve(response.data.allProducts);
          }
          else {
            resolve(null);
          }
        }, reject)
    })
  }

  // to create new product
  createNewProduct(formvalue) {
    return new Promise((resolve, reject) => {

      this.configurationService.ADD_PRODUCTS(formvalue)
        .subscribe((response: any) => {
          if (response && response.data && response.data.createProduct && response.data.createProduct.product) {
            resolve(response.data.createProduct.product);
          }
          else {
            resolve(null);
          }
        }, err => {

          reject(err);
        })
    })
  }

  // to delete product
  deleteProduct(formvalue) {
    return new Promise((resolve, reject) => {

      this.configurationService.DELETE_PRODUCTS(formvalue)
        .subscribe((response: any) => {
          if (response && response.data && response.data.updateProductByProductId && response.data.updateProductByProductId.product) {
            resolve(response.data.updateProductByProductId.product);
          }
          else {
            resolve(null);
          }
        }, err => {

          reject(err);
        })
    })
  }

  // to update product
  updateProduct(productId, formvalue) {
    return new Promise((resolve, reject) => {

      this.configurationService.UPDATE_PRODUCTS(productId, formvalue)
        .subscribe((response: any) => {
          if (response && response.data && response.data.updateProductByProductId && response.data.updateProductByProductId.product) {
            resolve(response.data.updateProductByProductId.product);
          }
          else {
            resolve(null);
          }
        }, err => {

          reject(err);
        })
    })
  }


  // to get market list
  getMarketList(limit: number, offset: number) {
    let queryParam = {};
    if (limit) {
      queryParam = {
        "limit": limit,
        "offset": offset
      }
    }

    return new Promise((resolve, reject) => {
      this.configurationService
        .GET_MARKETS(queryParam)
        .valueChanges
        .subscribe((response: any) => {
          if (response && response.data && response.data.allMarkets) {
            resolve(response.data.allMarkets);
          }
          else {
            resolve(null);
          }
        }, reject)
    })
  }

  // to create market
  createNewMarket(formvalue) {
    return new Promise((resolve, reject) => {

      this.configurationService.ADD_MARKET(formvalue)
        .subscribe((response: any) => {
          if (response && response.data && response.data.createMarket && response.data.createMarket.market) {
            resolve(response.data.createMarket.market);
          }
          else {
            resolve(null);
          }
        }, err => {

          reject(err);
        })
    })
  }

  // to delete market
  deleteMarket(formvalue) {
    return new Promise((resolve, reject) => {

      this.configurationService.DELETE_MARKETS(formvalue)
        .subscribe((response: any) => {
          if (response && response.data && response.data.updateMarketByMarketId && response.data.updateMarketByMarketId.market) {
            resolve(response.data.updateMarketByMarketId.market);
          }
          else {
            resolve(null);
          }
        }, err => {

          reject(err);
        })
    })
  }

  // to update market
  updateMarket(marketId, formvalue) {
    return new Promise((resolve, reject) => {

      this.configurationService.UPDATE_MARKETS(marketId, formvalue)
        .subscribe((response: any) => {
          if (response && response.data && response.data.updateMarketByMarketId && response.data.updateMarketByMarketId.market) {
            resolve(response.data.updateMarketByMarketId.market);
          }
          else {
            resolve(null);
          }
        }, err => {

          reject(err);
        })
    })
  }

  // to create firm
  createNewFirm(formvalue) {
    return new Promise((resolve, reject) => {

      this.configurationService.ADD_FIRM(formvalue)
        .subscribe((response: any) => {
          if (response && response.data && response.data.createFirm && response.data.createFirm.firm) {
            resolve(response.data.createFirm.firm);
          }
          else {
            resolve(null);
          }
        }, err => {

          reject(err);
        })
    })
  }

  // to create office
  createNewOffice(formvalue) {
    return new Promise((resolve, reject) => {

      this.configurationService.ADD_OFFICE(formvalue)
        .subscribe((response: any) => {
          if (response && response.data && response.data.createOffice && response.data.createOffice.office) {
            resolve(response.data.createOffice.office);
          }
          else {
            resolve(null);
          }
        }, err => {

          reject(err);
        })
    })
  }

  // to get firm list
  getFirmList(limit: number, offset: number, marketId: number) {
    let queryParam = {};
    if (limit) {
      queryParam = {
        "limit": limit,
        "offset": offset,
        "marketId": marketId
      }
    }

    return new Promise((resolve, reject) => {
      this.configurationService
        .GET_FIRMS(queryParam)
        .valueChanges
        .subscribe((response: any) => {
          if (response && response.data && response.data.allMarketsMultiFirms) {
            resolve(response.data.allMarketsMultiFirms);
          }
          else {
            resolve(null);
          }
        }, reject)
    })
  }

  // to delete firm
  deleteFirm(formvalue) {
    return new Promise((resolve, reject) => {

      this.configurationService.DELETE_FIRMS(formvalue)
        .subscribe((response: any) => {
          if (response && response.data && response.data.updateFirmByFirmId && response.data.updateFirmByFirmId.firm) {
            resolve(response.data.updateFirmByFirmId.firm);
          }
          else {
            resolve(null);
          }
        }, err => {

          reject(err);
        })
    })
  }

  // to update firm
  updateFirm(firmId, formvalue) {
    return new Promise((resolve, reject) => {

      this.configurationService.UPDATE_FIRMS(firmId, formvalue)
        .subscribe((response: any) => {
          if (response && response.data && response.data.updateFirmByFirmId && response.data.updateFirmByFirmId.firm) {
            resolve(response.data.updateFirmByFirmId.firm);
          }
          else {
            resolve(null);
          }
        }, err => {

          reject(err);
        })
    })
  }

  // to get office list
  getOfficeList(limit: number, offset: number, marketId: number, firmId: number) {
    let queryParam = {};
    if (limit) {
      queryParam = {
        "limit": limit,
        "offset": offset,
        "firmId": firmId,
        "marketId": marketId
      }
    }

    return new Promise((resolve, reject) => {
      this.configurationService
        .GET_OFFICES(queryParam)
        .valueChanges
        .subscribe((response: any) => {
          if (response && response.data && response.data.allFirmsMultiOffices) {
            resolve(response.data.allFirmsMultiOffices);
          }
          else {
            resolve(null);
          }
        }, reject)
    })
  }

  // to get status list
  getstatusList(limit: number, offset: number) {
    let queryParam = {};
    if (limit) {
      queryParam = {
        "limit": limit,
        "offset": offset
      }
    }

    return new Promise((resolve, reject) => {
      this.configurationService
        .GET_STATUS(queryParam)
        .valueChanges
        .subscribe((response: any) => {
          if (response && response.data && response.data.allStatuses) {
            resolve(response.data.allStatuses);
          }
          else {
            resolve(null);
          }
        }, reject)
    })
  }


  // to delete office
  deleteOffice(formvalue) {
    return new Promise((resolve, reject) => {

      this.configurationService.DELETE_OFFICES(formvalue)
        .subscribe((response: any) => {
          if (response && response.data && response.data.updateOfficeByOfficeId && response.data.updateOfficeByOfficeId.office) {
            resolve(response.data.updateOfficeByOfficeId.office);
          }
          else {
            resolve(null);
          }
        }, err => {

          reject(err);
        })
    })
  }

  // to update office
  updateOffice(officeId, formvalue) {
    return new Promise((resolve, reject) => {

      this.configurationService.UPDATE_OFFICES(officeId, formvalue)
        .subscribe((response: any) => {
          if (response && response.data && response.data.updateOfficeByOfficeId && response.data.updateOfficeByOfficeId.office) {
            resolve(response.data.updateOfficeByOfficeId.office);
          }
          else {
            resolve(null);
          }
        }, err => {

          reject(err);
        })
    })
  }

  updateStatus(statusId, formvalue) {
    return new Promise((resolve, reject) => {

      this.configurationService.UPDATE_STATUS(statusId, formvalue)
        .subscribe((response: any) => {
          if (response && response.data && response.data.updateStatusByStatusId && response.data.updateStatusByStatusId.status) {
            resolve(response.data.updateStatusByStatusId.status);
          }
          else {
            resolve(null);
          }
        }, err => {

          reject(err);
        })
    })
  }

  // to create multi market
  createNewMultiMarket(formvalue) {
    return new Promise((resolve, reject) => {

      this.configurationService.ADD_MARKET_MULTI_FIRMS(formvalue)
        .subscribe((response: any) => {
          if (response && response.data && response.data.createMarketsMultiFirm && response.data.createMarketsMultiFirm.marketsMultiFirm) {
            resolve(response.data.createMarketsMultiFirm.marketsMultiFirm);
          }
          else {
            resolve(null);
          }
        }, err => {

          reject(err);
        })
    })
  }

  // to update multi market
  updateMultiMarket(firmId, formvalue) {
    return new Promise((resolve, reject) => {

      this.configurationService.EDIT_MARKET_MULTI_FIRMS(firmId, formvalue)
        .subscribe((response: any) => {
          if (response && response.data && response.data.updateMarketsMultiFirmByMarketsMultiFirmsId && response.data.updateMarketsMultiFirmByMarketsMultiFirmsId.marketsMultiFirm) {
            resolve(response.data.updateMarketsMultiFirmByMarketsMultiFirmsId.marketsMultiFirm);
          }
          else {
            resolve(null);
          }
        }, err => {

          reject(err);
        })
    })
  }

  // to update multi office
  updateMultiOffice(officeId, formvalue) {
    return new Promise((resolve, reject) => {

      this.configurationService.EDIT_FIRMS_MULTI_OFFICES(officeId, formvalue)
        .subscribe((response: any) => {
          if (response && response.data && response.data.updateFirmsMultiOfficeByFirmsMultiOfficesId && response.data.updateFirmsMultiOfficeByFirmsMultiOfficesId.firmsMultiOffice) {
            resolve(response.data.updateFirmsMultiOfficeByFirmsMultiOfficesId.firmsMultiOffice);
          }
          else {
            resolve(null);
          }
        }, err => {

          reject(err);
        })
    })
  }

  // to create multi firms
  createNewMultiFirms(formvalue) {
    return new Promise((resolve, reject) => {

      this.configurationService.ADD_FIRMS_MULTI_OFFICES(formvalue)
        .subscribe((response: any) => {
          if (response && response.data && response.data.createFirmsMultiOffice && response.data.createFirmsMultiOffice.firmsMultiOffice) {
            resolve(response.data.createFirmsMultiOffice.firmsMultiOffice);
          }
          else {
            resolve(null);
          }
        }, err => {

          reject(err);
        })
    })
  }

  // to delete market multi
  deleteMarketMulti(formvalue) {
    return new Promise((resolve, reject) => {

      this.configurationService.DELETE_MARKETS_MULTI(formvalue)
        .subscribe((response: any) => {
          if (response && response.data && response.data.updateMarketsMultiFirmByMarketsMultiFirmsId && response.data.updateMarketsMultiFirmByMarketsMultiFirmsId.marketsMultiFirm) {
            resolve(response.data.updateMarketsMultiFirmByMarketsMultiFirmsId.marketsMultiFirm);
          }
          else {
            resolve(null);
          }
        }, err => {

          reject(err);
        })
    })
  }

  // to delete firm multi
  deleteFirmsMulti(formvalue) {
    return new Promise((resolve, reject) => {

      this.configurationService.DELETE_FIRMS_MULTI(formvalue)
        .subscribe((response: any) => {
          if (response && response.data && response.data.updateFirmsMultiOfficeByFirmsMultiOfficesId && response.data.updateFirmsMultiOfficeByFirmsMultiOfficesId.firmsMultiOffice) {
            resolve(response.data.updateFirmsMultiOfficeByFirmsMultiOfficesId.firmsMultiOffice);
          }
          else {
            resolve(null);
          }
        }, err => {

          reject(err);
        })
    })
  }

  // insert sub list
  insertSubList(inputId, subArray, type) {
    return new Promise(async (resolve, reject) => {
      if (subArray && subArray.length > 0) {
        let finalData = [];
        let incrementCount = 0;

        for (let i = 0; i < subArray.length; i++) {
          let dataItem = subArray[i];
          if (type == "market_create") {
            let tempObject: any = {
              marketId: inputId ? inputId : null,
              firmId: dataItem ? dataItem : null,
            }

            this.createNewMultiMarket(tempObject)
              .then(async (data: any) => {

                if (data && data['marketId']) {
                  finalData = finalData.concat(data);
                }

                incrementCount = incrementCount + 1;
                if (subArray.length == incrementCount) {
                  resolve(finalData);
                }
              });
          }
          else {
            let tempObject: any = {
              firmId: inputId ? inputId : null,
              officeId: dataItem ? dataItem : null,
            }

            this.createNewMultiFirms(tempObject)
              .then(async (data: any) => {

                if (data && data['firmId']) {
                  finalData = finalData.concat(data);
                }

                incrementCount = incrementCount + 1;
                if (subArray.length == incrementCount) {
                  resolve(finalData);
                }
              });
          }

        }

      } else {
        resolve([]);
      }

    });
  }

  // update sub list
  updateSubOfficeList(subArray, firmId) {
    return new Promise(async (resolve, reject) => {
      if (subArray && subArray.length > 0) {
        let finalData = [];
        let incrementCount = 0;

        for (let i = 0; i < subArray.length; i++) {
          let dataItem = subArray[i];
          let updateObj = {
            "firmId": firmId,
            "updatedat": "now()"
          };

          this.updateMultiOffice(dataItem['firmsMultiOfficesId'], updateObj)
            .then(async (data: any) => {

              if (data && data['officeId']) {
                finalData = finalData.concat(data);
              }

              incrementCount = incrementCount + 1;
              if (subArray.length == incrementCount) {
                resolve(finalData);
              }
            });
        }

      } else {
        resolve([]);
      }

    });
  }


  // delete sub list
  deleteSubList(subArray, type) {
    return new Promise(async (resolve, reject) => {
      if (subArray && subArray.length > 0) {
        let finalData = [];
        let incrementCount = 0;

        for (let i = 0; i < subArray.length; i++) {
          let dataItem = subArray[i];
          if (type == "market_delete") {
            let tempObject: any = {
              "marketsMultiFirmsId": dataItem && dataItem['marketsMultiFirmsId'] ? dataItem['marketsMultiFirmsId'] : null,
              "marketsMultiFirmPatch": {
                "isDeletedYn": true,
                "updatedat": "now()"
              }
            }

            this.deleteMarketMulti(tempObject)
              .then(async (data: any) => {

                if (data && data['marketId']) {
                  finalData = finalData.concat(data);
                }

                incrementCount = incrementCount + 1;
                if (subArray.length == incrementCount) {
                  resolve(finalData);
                }
              });
          }
          else {
            let tempObject: any = {
              "firmsMultiOfficesId": dataItem && dataItem['firmsMultiOfficesId'] ? dataItem['firmsMultiOfficesId'] : null,
              "firmsMultiOfficePatch": {
                "isDeletedYn": true,
                "updatedat": "now()"
              }
            }

            this.deleteFirmsMulti(tempObject)
              .then(async (data: any) => {

                if (data && data['firmId']) {
                  finalData = finalData.concat(data);
                }

                incrementCount = incrementCount + 1;
                if (subArray.length == incrementCount) {
                  resolve(finalData);
                }
              });
          }

        }

      } else {
        resolve([]);
      }

    });
  }

  // to create coupons
  createNewCoupons(formvalue) {
    return new Promise((resolve, reject) => {

      this.configurationService.ADD_COUPON(formvalue)
        .subscribe((response: any) => {
          if (response && response.data && response.data.createCoupon && response.data.createCoupon.coupon) {
            resolve(response.data.createCoupon.coupon);
          }
          else {
            resolve(null);
          }
        }, err => {

          reject(err);
        })
    })
  }

  // to get coupon list
  getCouponsList(limit: number, offset: number) {
    let queryParam = {};
    if (limit) {
      queryParam = {
        "limit": limit,
        "offset": offset
      }
    }

    return new Promise((resolve, reject) => {
      this.configurationService
        .GET_COUPONS(queryParam)
        .valueChanges
        .subscribe((response: any) => {
          if (response && response.data && response.data.allCoupons) {
            resolve(response.data.allCoupons);
          }
          else {
            resolve(null);
          }
        }, reject)
    })
  }

  // to delete coupon
  deleteCoupon(formvalue) {
    return new Promise((resolve, reject) => {

      this.configurationService.DELETE_COUPONS(formvalue)
        .subscribe((response: any) => {
          if (response && response.data && response.data.updateCouponByCouponId && response.data.updateCouponByCouponId.coupon) {
            resolve(response.data.updateCouponByCouponId.coupon);
          }
          else {
            resolve(null);
          }
        }, err => {

          reject(err);
        })
    })
  }

  // to update coupom
  updateCoupon(couponId, formvalue) {
    return new Promise((resolve, reject) => {

      this.configurationService.UPDATE_COUPONS(couponId, formvalue)
        .subscribe((response: any) => {
          if (response && response.data && response.data.updateCouponByCouponId && response.data.updateCouponByCouponId.coupon) {
            resolve(response.data.updateCouponByCouponId.coupon);
          }
          else {
            resolve(null);
          }
        }, err => {

          reject(err);
        })
    })
  }

  // to get roles list
  getRolesList(limit: number, offset: number) {
    let queryParam = {};
    if (limit) {
      queryParam = {
        "limit": limit,
        "offset": offset
      }
    }

    return new Promise((resolve, reject) => {
      this.configurationService
        .GET_ROLES(queryParam)
        .valueChanges
        .subscribe((response: any) => {
          if (response && response.data && response.data.allRoles) {
            resolve(response.data.allRoles);
          }
          else {
            resolve(null);
          }
        }, reject)
    })
  }

  // to create role
  createNewRole(formvalue) {
    return new Promise((resolve, reject) => {

      this.configurationService.ADD_ROLE(formvalue)
        .subscribe((response: any) => {
          if (response && response.data && response.data.createRole && response.data.createRole.role) {
            resolve(response.data.createRole.role);
          }
          else {
            resolve(null);
          }
        }, err => {

          reject(err);
        })
    })
  }

  createNewStatus(payload) {
    return new Promise((resolve, reject) => {

      this.configurationService.ADD_STATUS(payload)
        .subscribe((response: any) => {
          if (response && response.data && response.data.createStatus && response.data.createStatus.status) {
            resolve(response.data.createStatus.status);
          }
          else {
            resolve(null);
          }
        }, err => {

          reject(err);
        })
    })
  }


  // to delete role
  deleteRole(formvalue) {
    return new Promise((resolve, reject) => {

      this.configurationService.DELETE_ROLES(formvalue)
        .subscribe((response: any) => {
          if (response && response.data && response.data.updateRoleByRoleId && response.data.updateRoleByRoleId.role) {
            resolve(response.data.updateRoleByRoleId.role);
          }
          else {
            resolve(null);
          }
        }, err => {

          reject(err);
        })
    })
  }

  // to update role
  updateRole(roleId, formvalue) {
    return new Promise((resolve, reject) => {

      this.configurationService.UPDATE_ROLES(roleId, formvalue)
        .subscribe((response: any) => {
          if (response && response.data && response.data.updateRoleByRoleId && response.data.updateRoleByRoleId.role) {
            resolve(response.data.updateRoleByRoleId.role);
          }
          else {
            resolve(null);
          }
        }, err => {

          reject(err);
        })
    })
  }

  // to get market based firm list
  getMarkedBasedFirmList(marketId: number) {
    return new Promise((resolve, reject) => {
      this.configurationService
        .GET_MARKET_FIRMS(marketId)
        .valueChanges
        .subscribe((response: any) => {
          if (response && response.data && response.data.allMarketsMultiFirms) {
            resolve(response.data.allMarketsMultiFirms);
          }
          else {
            resolve(null);
          }
        }, reject)
    })
  }

  // to get firm based office list
  getFirmBasedOfficeList(marketId: number, firmId: number) {
    return new Promise((resolve, reject) => {
      this.configurationService
        .GET_FIRM_OFFICES(marketId, firmId)
        .valueChanges
        .subscribe((response: any) => {
          if (response && response.data && response.data.allFirmsMultiOffices) {
            resolve(response.data.allFirmsMultiOffices);
          }
          else {
            resolve(null);
          }
        }, reject)
    })
  }

  createMarketsMultiFirms(marketId: number, firmId: number) {
    let formvalue = {
      "marketId": marketId,
      "firmId": firmId
    }
    return new Promise((resolve, reject) => {

      this.configurationService.ADD_MARKET_MULTI_FIRMS(formvalue)
        .subscribe((response: any) => {
          if (response && response.data && response.data.createMarketsMultiFirm && response.data.createMarketsMultiFirm.marketsMultiFirm) {
            resolve(response.data.createMarketsMultiFirm.marketsMultiFirm);
          }
          else {
            resolve(null);
          }
        }, err => {

          reject(err);
        })
    })
  }

  createFirmsMultiOffices(officeId: number, firmId: number, marketId: number) {
    let formvalue = {
      "officeId": officeId,
      "firmId": firmId,
      "marketId": marketId
    }
    return new Promise((resolve, reject) => {

      this.configurationService.ADD_FIRMS_MULTI_OFFICES(formvalue)
        .subscribe((response: any) => {
          if (response && response.data && response.data.createFirmsMultiOffice && response.data.createFirmsMultiOffice.firmsMultiOffice) {
            resolve(response.data.createFirmsMultiOffice.firmsMultiOffice);
          }
          else {
            resolve(null);
          }
        }, err => {

          reject(err);
        })
    })
  }


  // to get market based firm check list
  getMarkedBasedFirmCheckList(marketId: number, firmId: number) {
    return new Promise((resolve, reject) => {
      this.configurationService
        .GET_MARKET_FIRMS_CHECK(marketId, firmId)
        .valueChanges
        .subscribe((response: any) => {
          if (response && response.data && response.data.allMarketsMultiFirms) {
            resolve(response.data.allMarketsMultiFirms);
          }
          else {
            resolve(null);
          }
        }, reject)
    })
  }

  // to get firm based office check list
  getFirmBasedOfficeCheckList(marketId: number, firmId: number, officeId: number) {
    return new Promise((resolve, reject) => {
      this.configurationService
        .GET_FIRM_OFFICES_CHECK(marketId, firmId, officeId)
        .valueChanges
        .subscribe((response: any) => {
          if (response && response.data && response.data.allFirmsMultiOffices) {
            resolve(response.data.allFirmsMultiOffices);
          }
          else {
            resolve(null);
          }
        }, reject)
    })
  }

  getOrderByMarketsFirmsOffices(marketId: number, firmId: number, officeId: number,) {
    let queryParam = {};
    queryParam = {
      marketId: marketId,
      firmId: firmId,
      officeId: officeId
    }

    return new Promise((resolve, reject) => {
      this.configurationService
        .List_Order_By_Markets(queryParam)
        .valueChanges
        .subscribe((response: any) => {
          if (response && response.data && response.data.allOrders) {
            resolve(response.data.allOrders);
          }
          else {
            resolve(null);
          }
        }, reject)
    })
  }

  // to get market list
  getMarket() {
    return new Promise((resolve, reject) => {
      this.configurationService
        .GET_MARKET()
        .valueChanges
        .subscribe((response: any) => {
          if (response && response.data && response.data.allMarkets) {
            resolve(response.data.allMarkets);
          }
          else {
            resolve(null);
          }
        }, reject)
    })
  }

  // to get list order by markets
  getListOrderByMarket(marketId: number) {
    return new Promise((resolve, reject) => {
      this.configurationService
        .GET_ORDER_BY_MARKETS(marketId)
        .valueChanges
        .subscribe((response: any) => {
          if (response && response.data && response.data.allOrders) {
            resolve(response.data.allOrders);
          }
          else {
            resolve(null);
          }
        }, reject)
    })
  }

  // to get market BY NAME
  getMarketByName(marketName) {
    return new Promise((resolve, reject) => {
      this.configurationService
        .GET_MARKETS_BY_NAME(marketName)
        .valueChanges
        .subscribe((response: any) => {
          if (response && response.data && response.data.allMarkets) {
            resolve(response.data.allMarkets);
          }
          else {
            resolve(null);
          }
        }, reject)
    })
  }

  // to get firm BY NAME
  getFirmByName(firmName) {
    return new Promise((resolve, reject) => {
      this.configurationService
        .GET_FIRMS_BY_NAME(firmName)
        .valueChanges
        .subscribe((response: any) => {
          if (response && response.data && response.data.allFirms) {
            resolve(response.data.allFirms);
          }
          else {
            resolve(null);
          }
        }, reject)
    })
  }

  // to get offices BY NAME
  getOfficesByName(officeName) {
    return new Promise((resolve, reject) => {
      this.configurationService
        .GET_OFFICES_BY_NAME(officeName)
        .valueChanges
        .subscribe((response: any) => {
          if (response && response.data && response.data.allOffices) {
            resolve(response.data.allOffices);
          }
          else {
            resolve(null);
          }
        }, reject)
    })
  }


  // to get market list
  getMarketLimitList(limit: number, offset: number) {
    let queryParam = {};
    if (limit) {
      queryParam = {
        "limit": limit,
        "offset": offset
      }
    }

    return new Promise((resolve, reject) => {
      this.configurationService
        .GET_ALL_MARKET_LIMIT_OFFSET(queryParam)
        .valueChanges
        .subscribe((response: any) => {
          if (response && response.data && response.data.allMarkets) {
            resolve(response.data.allMarkets);
          }
          else {
            resolve(null);
          }
        }, reject)
    })
  }
  // to get mail type list
  getMailTypesList(limit: number, offset: number) {
    let queryParam = {};
    if (limit) {
      queryParam = {
        "limit": limit,
        "offset": offset
      }
    }
    return new Promise((resolve, reject) => {
      this.configurationService
        .GET_MAIL_TYPES(queryParam)
        .valueChanges
        .subscribe((response: any) => {
          if (response && response.data && response.data.allEmailTypes) {
            resolve(response.data.allEmailTypes);
          }
          else {
            resolve(null);
          }
        }, reject)
    })
  }

  createNewMailTypes(payload) {
    return new Promise((resolve, reject) => {

      this.configurationService.ADD_MAIL_TYPES(payload)
        .subscribe((response: any) => {
          if (response && response.data && response.data.createEmailType && response.data.createEmailType.emailType) {
            resolve(response.data.createEmailType.emailType);
          }
          else {
            resolve(null);
          }
        }, err => {

          reject(err);
        })
    })
  }

  updateEmailType(emailTypeId, formvalue) {
    return new Promise((resolve, reject) => {

      this.configurationService.UPDATE_EMAIL_TYPES(emailTypeId, formvalue)
        .subscribe((response: any) => {
          if (response && response.data && response.data.updateEmailTypeByEmailTypeId && response.data.updateEmailTypeByEmailTypeId.emailType) {
            resolve(response.data.updateEmailTypeByEmailTypeId.emailType);
          }
          else {
            resolve(null);
          }
        }, err => {

          reject(err);
        })
    })
  }

  // to get mail type content list
  getMailTypeContentList(limit: number, offset: number) {
    let queryParam = {};
    if (limit) {
      queryParam = {
        "limit": limit,
        "offset": offset
      }
    }
    return new Promise((resolve, reject) => {
      this.configurationService
        .GET_MAIL_TYPE_CONTENTS(queryParam)
        .valueChanges
        .subscribe((response: any) => {
          if (response && response.data && response.data.allEmailTypeContents) {
            resolve(response.data.allEmailTypeContents);
          }
          else {
            resolve(null);
          }
        }, reject)
    })
  }

  createNewMailTypeContent(payload) {
    return new Promise((resolve, reject) => {

      this.configurationService.ADD_MAIL_TYPE_CONTENTS(payload)
        .subscribe((response: any) => {
          if (response && response.data && response.data.createEmailTypeContent && response.data.createEmailTypeContent.emailTypeContent) {
            resolve(response.data.createEmailTypeContent.emailTypeContent);
          }
          else {
            resolve(null);
          }
        }, err => {

          reject(err);
        })
    })
  }

  // to get mail type dropdown list
  getEmailDropDownList() {
    return new Promise((resolve, reject) => {
      this.configurationService
        .GET_MAIL_TYPE_DROP_DOWN_LIST()
        .valueChanges
        .subscribe((response: any) => {
          if (response && response.data && response.data.allEmailTypes) {
            resolve(response.data.allEmailTypes);
          }
          else {
            resolve(null);
          }
        }, reject)
    })
  }

  updateEmailTypeContent(emailTypeContentId, formvalue) {
    return new Promise((resolve, reject) => {

      this.configurationService.UPDATE_EMAIL_TYPE_CONTENTS(emailTypeContentId, formvalue)
        .subscribe((response: any) => {
          if (response && response.data && response.data.updateEmailTypeContentByEmailTypeContentId && response.data.updateEmailTypeContentByEmailTypeContentId.emailTypeContent) {
            resolve(response.data.updateEmailTypeContentByEmailTypeContentId.emailTypeContent);
          }
          else {
            resolve(null);
          }
        }, err => {

          reject(err);
        })
    })
  }

  createBreakingNews(payload) {
    return new Promise((resolve, reject) => {

      this.configurationService.ADD_BREAKING_NEWS(payload)
        .subscribe((response: any) => {
          if (response && response.data && response.data.createBreakingNew && response.data.createBreakingNew.breakingNew) {
            resolve(response.data.createBreakingNew.breakingNew);
          }
          else {
            resolve(null);
          }
        }, err => {

          reject(err);
        })
    })
  }

  // to get breaking news list
  getBreakingNewsList(limit: number, offset: number) {
    let queryParam = {};
    if (limit) {
      queryParam = {
        "limit": limit,
        "offset": offset
      }
    }

    return new Promise((resolve, reject) => {
      this.configurationService
        .GET_ALL_BREAKING_NEWS(queryParam)
        .valueChanges
        .subscribe((response: any) => {
          if (response && response.data && response.data.allBreakingNews) {
            resolve(response.data.allBreakingNews);
          }
          else {
            resolve(null);
          }
        }, reject)
    })
  }

  updateBreakingNews(breakingNewsId, formvalue) {
    return new Promise((resolve, reject) => {

      this.configurationService.UPDATE_BREAKING_NEWS(breakingNewsId, formvalue)
        .subscribe((response: any) => {
          if (response && response.data && response.data.updateBreakingNewByBreakingNewsId && response.data.updateBreakingNewByBreakingNewsId.breakingNew) {
            resolve(response.data.updateBreakingNewByBreakingNewsId.breakingNew);
          }
          else {
            resolve(null);
          }
        }, err => {

          reject(err);
        })
    })
  }

  logoUpload(payload, firmId: string, fileName) {
    let formData = new FormData();
    formData.append('file', new Blob([payload], { type: 'image/png' }), fileName);
    return new Promise((resolve, reject) => {
      const url = apiCalls.logoUploadUrl + '?fileName=' + fileName + '&firmId=' + firmId;
      this.http.post(url, formData)
        .subscribe(data => {
          resolve(data);
        }, error => {
          reject(error);
        })
    })
  }

  updateFirms(formvalue) {
    return new Promise((resolve, reject) => {

      this.configurationService.UPDATE_LOGOURL(formvalue)
        .subscribe((response: any) => {
          if (response && response.data && response.data.updateFirmByFirmId && response.data.updateFirmByFirmId.firm) {
            resolve(response.data.updateFirmByFirmId.firm);
          }
          else {
            resolve(null);
          }
        }, err => {

          reject(err);
        })
    })
  }
}





// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/configuration/configuration.service.ts